import React from "react";

const PreviewModal = ({ item, onClose }) => {
    if (!item) return null;

    const isVideo = item.publicUrl.endsWith(".mp4");
    const isPDF = item.publicUrl.endsWith(".pdf");

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 px-2"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-md w-full max-w-3xl h-[80vh] relative flex flex-col overflow-hidden"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-between px-4 py-2 border-b">
                    <h2 className="text-sm font-semibold text-gray-800 truncate">
                        {item.name}
                    </h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-black text-lg"
                    >
                        ✕
                    </button>
                </div>

                <div className="flex-1 bg-black flex items-center justify-center">
                    {isVideo ? (
                        <video
                            src={item.publicUrl}
                            controls
                            className="max-w-full max-h-full"
                        />
                    ) : isPDF ? (
                        <iframe
                            src={item.publicUrl}
                            title="PDF Viewer"
                            className="w-full h-full"
                        />
                    ) : (
                        <div className="p-4 text-center text-gray-500 text-sm">
                            Unsupported file format.
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PreviewModal;
